import { createStore, createHook } from '@atlassian/react-sweet-state';
import { actions, type Actions } from './actions';
import type { State } from './types';

export const initialState = {
	isLoading: true,
	isEnabled: false,
	error: null,
} as const;

const IsSubTasksEnabledStore = createStore<State, Actions>({
	initialState,
	actions,
	name: 'admin-pages-issue-types-is-sub-task-enabled',
});

export const useIsSubTasksEnabled = createHook(IsSubTasksEnabledStore);
